const nodes = document.querySelectorAll('.j-quantity-calc')

if (nodes && nodes.length) {
	function changeQuantity(input, offset) {
		input.value = Math.max(
			parseInt(input.value) + offset,
			parseInt(input.min) || 0
		)
	}

	nodes.forEach((node) => {
		const btnAdd = [...node.getElementsByClassName('j-quantity-calc--add')][0]
		const btnRemove = [
			...node.getElementsByClassName('j-quantity-calc--remove'),
		][0]
		const input = node.querySelector('input')
		if (input && btnAdd) {
			btnAdd.addEventListener('click', () => changeQuantity(input, 1))
		}
		if (input && btnRemove) {
			btnRemove.addEventListener('click', () => changeQuantity(input, -1))
		}
	})
}
